<div class="workflow-crud">
  <h2 class="mb-4">{{_(KEYS.CRUD.WORKFLOW)}}</h2>

  <form [formGroup]="workflowForm">

    <div class="mb-3" formGroupName="name">
      <label>{{_(KEYS.CRUD.STAGE_NAME)}}</label>
      <input class="form-control" formControlName="de_DE" placeholder="{{_(KEYS.CRUD.ENTER_WORKFLOW_NAME)}}" />
    </div>

    <div class="mb-3" formGroupName="description">
      <label>{{_(KEYS.CRUD.STAGE_DESCRIPTION)}}</label>
      <textarea class="form-control" formControlName="de_DE" placeholder="{{_(KEYS.CRUD.ENTER_WORKFLOW_DESCRIPTION)}}"></textarea>
    </div>

    <ul class="nav nav-tabs mt-4">
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab==='steps'" href="javascript:void(0)" (click)="activeTab='steps'">{{_(KEYS.CRUD.STAGES)}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab==='variables'" href="javascript:void(0)" (click)="activeTab='variables'">{{_(KEYS.CRUD.VARIABLES)}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab==='conditions'" href="javascript:void(0)" (click)="activeTab='conditions'">{{_(KEYS.CRUD.CONDITIONS)}}</a>
      </li>
    </ul>

    <div class="tab-content pt-3">
      <div class="tab-pane" [class.active]="activeTab==='steps'">
        <div formArrayName="stages">
          <div *ngFor="let stage of stages.controls; index as i" [formGroupName]="i" class="mb-3 border rounded">

            <div class="p-2 bg-light d-flex justify-content-between align-items-center" style="cursor: pointer;"
                 (click)="toggleStage(i)">
              <strong>
                <button class="btn btn-success btn-sm stage-number">{{i+1}}</button>&nbsp;
                <span class="stage-name">{{getStageDisplayName(i)}}</span>
              </strong>
              <i class="fa" [ngClass]="collapsedStages[i] ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
            </div>

            <div class="p-3" *ngIf="!collapsedStages[i]">
              <div formGroupName="name" class="mb-3">
                <label>{{_(KEYS.CRUD.STAGE_NAME)}}</label>
                <input class="form-control" formControlName="de_DE" placeholder="{{_(KEYS.CRUD.ENTER_STAGE_NAME)}}" />
              </div>

              <div formGroupName="description" class="mb-3">
                <label>{{_(KEYS.CRUD.STAGE_DESCRIPTION)}}</label>
                <textarea class="form-control" formControlName="de_DE" placeholder="{{_(KEYS.CRUD.ENTER_STAGE_DESCRIPTION)}}"></textarea>
              </div>

              <div class="form-check flag-option mb-2">
                <input type="checkbox" class="form-check-input" formControlName="autoStart" id="autoStart-{{i}}">
                <label class="form-check-label" for="autoStart-{{i}}">{{_(KEYS.CRUD.AUTO_START_STEP)}}</label>
              </div>

              <div class="form-check flag-option mb-2">
                <input type="checkbox" class="form-check-input" formControlName="skipSigning" id="skipSigning-{{i}}">
                <label class="form-check-label" for="skipSigning-{{i}}">{{_(KEYS.CRUD.SKIP_SIGNING)}}</label>
              </div>

              <div class="form-check flag-option mb-2">
                <input type="checkbox" class="form-check-input" formControlName="generateExports" id="generateExports-{{i}}">
                <label class="form-check-label" for="generateExports-{{i}}">{{_(KEYS.CRUD.GENERATE_EXPORTS)}}</label>
              </div>

              <div class="form-check flag-option mb-2">
                <input type="checkbox" class="form-check-input" formControlName="generateFormPDFs" id="generateFormPDFs-{{i}}">
                <label class="form-check-label" for="generateFormPDFs-{{i}}">{{_(KEYS.CRUD.GENERATE_FORM_PDFS)}}</label>
              </div>

              <div class="form-check flag-option mb-3">
                <input type="checkbox" class="form-check-input" formControlName="prefill" id="prefill-{{i}}">
                <label class="form-check-label" for="prefill-{{i}}">{{_(KEYS.CRUD.PREFILL)}}</label>
              </div>

              <div class="mb-3">
                <label>{{_(KEYS.CRUD.STAGE_QUESTIONNAIRES)}}</label>
                <app-questionnaire-select
                  [enableGroups]="true"
                  [enableWorkflows]="false"
                  [selected]="stage.get('questionnaires').value"
                  (selectedChange)="onQuestionnairesSelect($event, i)">
                </app-questionnaire-select>
              </div>

              <button type="button" class="btn btn-danger" (click)="onRemoveStage(i)">
                <i class="fa fa-trash"></i> {{_(KEYS.CRUD.DELETE_STAGE)}}
              </button>
            </div>
          </div>
        </div>

        <button type="button" class="btn btn-success mt-2" (click)="onAddStage()">
          <i class="fa fa-plus"></i> {{_(KEYS.CRUD.ADD_STAGE)}}
        </button>
      </div>

      <div class="tab-pane" [class.active]="activeTab==='variables'">
        <div class="alert alert-info" role="alert">
          <i class="fa fa-info-circle"></i> {{_(KEYS.CRUD.VARIABLE_HELP)}}
        </div>

        <div class="form-inline mb-3">
          <div class="form-group mr-2 mb-2">
            <label class="mr-2">{{_(KEYS.CRUD.VARIABLE_NAME)}}:</label>
            <input class="form-control" [(ngModel)]="newVariable.name" [ngModelOptions]="{standalone: true}" name="varName" #varNameModel="ngModel" required pattern="^[A-Za-z_$][A-Za-z0-9_$]*$" placeholder="..." />
          </div>
          <div class="form-group mr-2 mb-2">
            <label class="mr-2">{{_(KEYS.CRUD.VARIABLE_TYPE)}}:</label>
            <select class="form-control" [(ngModel)]="newVariable.type" [ngModelOptions]="{standalone: true}" name="varType">
              <option [ngValue]="'questionnaire'">{{_(KEYS.CRUD.VARIABLE_QUESTIONNAIRE)}}</option>
              <option [ngValue]="'survey'">{{_(KEYS.CRUD.VARIABLE_SURVEY)}}</option>
            </select>
          </div>
          <div class="form-group mr-2 mb-2">
            <label class="mr-2">{{_(KEYS.CRUD.VARIABLE_QUESTIONNAIRE)}}:</label>
            <select class="form-control variables-questionnaire-select" [(ngModel)]="newVariable.questionnaireId" [ngModelOptions]="{standalone: true}" name="varQid" [disabled]="newVariable.type !== 'questionnaire'">
              <option value="" disabled>{{_(KEYS.CRUD.PLEASE_SELECT)}}</option>
              <option *ngFor="let q of filteredQuestionnaires" [value]="q.id">{{getQuestionnaireTitle(q.id)}}</option>
            </select>
          </div>
          <div class="form-group mr-2 mb-2" *ngIf="newVariable.type === 'questionnaire'">
            <label class="mr-2">{{_(KEYS.CRUD.VARIABLE_VARIABLE)}}:</label>
            <select class="form-control variables-variable-select" [(ngModel)]="newVariable.variable" [ngModelOptions]="{standalone: true}" name="varVar" [disabled]="!newVariable.questionnaireId">
              <option value="" disabled>{{_(KEYS.CRUD.PLEASE_SELECT)}}</option>
              <option *ngFor="let v of questionnaireIdToVariables[newVariable.questionnaireId] || []" [value]="v">{{v}}</option>
            </select>
          </div>
          <div class="form-group mr-2 mb-2" *ngIf="newVariable.type === 'survey'">
            <label class="mr-2">{{_(KEYS.CRUD.VARIABLE_VARIABLE)}}:</label>
            <select class="form-control variables-variable-select" [(ngModel)]="newVariable.variable" [ngModelOptions]="{standalone: true}" name="varVarSurvey">
              <option value="" disabled>{{_(KEYS.CRUD.PLEASE_SELECT)}}</option>
              <option *ngFor="let v of surveyVariables" [value]="v">{{v}}</option>
            </select>
          </div>
          <button type="button" class="btn btn-success mb-2" (click)="onAddVariable()" [disabled]="!varNameModel.valid || !newVariable.variable || (newVariable.type === 'questionnaire' && !newVariable.questionnaireId)">
            <i class="fa fa-plus"></i>
          </button>
        </div>

        <div class="table-responsive" *ngIf="variables.length > 0">
          <table class="table table-sm variables-table">
            <thead>
            <tr>
              <th>{{_(KEYS.CRUD.VARIABLE_NAME)}}</th>
              <th>{{_(KEYS.CRUD.VARIABLE_TYPE)}}</th>
              <th>{{_(KEYS.CRUD.VARIABLE_QUESTIONNAIRE)}}</th>
              <th>{{_(KEYS.CRUD.VARIABLE_VARIABLE)}}</th>
              <th>{{_(KEYS.CRUD.VARIABLE_OPTIONS)}}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let v of variables.controls; index as vi" [formGroup]="v">
              <td>{{v.get('name')!.value}}</td>
              <td>{{ v.get('target.type')!.value === 'survey' ? _(KEYS.CRUD.VARIABLE_SURVEY) : _(KEYS.CRUD.VARIABLE_QUESTIONNAIRE) }}</td>
              <td>{{ v.get('target.type')!.value === 'survey' ? '-' : getQuestionnaireTitle(v.get('target.id')!.value) }}</td>
              <td>{{v.get('target.variable')!.value}}</td>
              <td>
                <button type="button" class="btn btn-danger btn-sm" (click)="onRemoveVariable(vi)">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="tab-pane" [class.active]="activeTab==='conditions'">
        <div class="alert alert-info" role="alert">
          <i class="fa fa-info-circle"></i> {{_(KEYS.CRUD.CONDITIONS_HELP_INFO)}}
        </div>
        <div class="form-inline mb-3">
          <label class="mr-2">{{_(KEYS.CRUD.CONDITIONS_FOR_STAGE)}}</label>
          <select class="form-control mr-2" [(ngModel)]="stageToAdd" [ngModelOptions]="{standalone: true}">
            <option [ngValue]="''" disabled>{{_(KEYS.CRUD.PLEASE_SELECT)}}</option>
            <option *ngFor="let s of stages.controls; let i = index" [ngValue]="i" [disabled]="conditionsVisibleStages.includes(i) || i == 0">
              [{{i+1}}] - {{getStageDisplayName(i)}}
            </option>
          </select>
          <button type="button" class="btn btn-success" (click)="addConditionsStage()" [disabled]="stageToAdd === ''">
            <i class="fa fa-plus"></i> {{_(KEYS.CRUD.CONDITIONS_ADD)}}
          </button>
        </div>

        <div *ngFor="let i of conditionsVisibleStages" class="mb-3">
          <div class="p-2 bg-light d-flex justify-content-between align-items-center">
            <div>
              <button class="btn btn-success btn-sm stage-number mr-2">{{i+1}}</button>
              <span class="stage-name"><strong>{{getStageDisplayName(i)}}</strong> - {{_(KEYS.CRUD.CONDITIONS_ONLY_EXECUTE_IF)}}</span>
            </div>
            <button type="button" class="btn btn-danger btn-sm" (click)="removeConditionsStage(i)"><i class="fa fa-trash"></i></button>
          </div>
          <div class="p-3 border" *ngIf="i>0">
            <app-workflow-stage-conditions [workflow]="workflowForm.value" [stageIndex]="i"></app-workflow-stage-conditions>
          </div>
        </div>
      </div>
    </div>

    <hr>

    <div>
      <button type="button" class="btn btn-primary" [disabled]="!workflowForm.valid" (click)="onSubmit()">
        <i class="fa fa-save"></i> {{_(KEYS.CRUD.SAVE_WORKFLOW)}}
      </button>
    </div>
  </form>
</div>
